import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {concatMap, filter, merge, tap} from 'rxjs';
import {AccountResetRequestedEvent} from 'src/app/shared/application/events/account/account-reset-requested.event';
import {
  AccountWithoutBookingActivatedEvent
} from 'src/app/shared/application/events/account/account-without-booking-activated.event';
import {BookingDeactivatedEvent} from 'src/app/shared/application/events/booking/booking-deactivated.event';
import {EVENT_BUS} from 'src/app/shared/domain/tokens/event-bus.token';
import {BookingLockCheckedEvent} from "../../../../../shared/application/events/booking/booking-lock-checked.event";
import {BOOKING_SESSION} from '../../domain/tokens/booking-session.token';
import {
  AccountEntriesRejectedEvent
} from "../../../../../shared/application/events/account/account-entries-rejected.event";
import {BookingExitedEvent} from "../../../../../shared/application/events/booking/booking-exited.event";
import {
  BookingActivationStartedEvent
} from "../../../../../shared/application/events/booking/booking-activation-started.event";
import {BookingClosedEvent} from "../../../../../shared/application/events/booking/booking-closed.event";

@Injectable()
export class DeactivateBookingSubscriber {
  private readonly bookingSession = inject(BOOKING_SESSION);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    merge(
      this.eventBus.ofType(AccountResetRequestedEvent),
      this.eventBus.ofType(AccountEntriesRejectedEvent),
      this.eventBus.ofType(BookingActivationStartedEvent),
      this.eventBus.ofType(AccountWithoutBookingActivatedEvent),
      this.eventBus.ofType(BookingClosedEvent),
      this.eventBus.ofType(BookingExitedEvent),
      this.eventBus.ofType(BookingLockCheckedEvent).pipe(
        filter(event => event.payload.isLocked)
      ),
    ).pipe(
      concatMap(() => this.bookingSession.delete()),
      tap(() => this.eventBus.publish(new BookingDeactivatedEvent())),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
